export default {
    state: {
        firstName: localStorage.getItem('firstName') === 0 ? 0 : localStorage.getItem('firstName'),
    },
    mutations: {
        setFirstName(state, firstName) {
            state.firstName = firstName;
        }  
    },
    actions: {
        setFirstName({commit}, firstName) {
            localStorage.setItem('firstName', firstName)
            commit('setFirstName', firstName);
        }
    },
};